import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateRateSourceRequest extends BaseUpdateRequest{
    name: string = '';
    baseRateSourceId: string;
}
